import type React from 'react';

export const MobilePageWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-1 justify-center md:items-center md:bg-muted md:p-4">
    <div className="flex min-h-svh w-full flex-col bg-background p-6 md:min-h-[700px] md:max-w-sm md:rounded-3xl md:border-2 md:border-dashed md:border-muted-foreground/25 md:px-6 md:py-12">
      {children}
    </div>
  </div>
);
